import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "login" */ '@/page/index.vue'),
        meta: { title: '登录' }
    },
    // {
    //     path: '/home/personal',
    //     component: () => import(/* webpackChunkName: "login" */ '@/page/home/personal.vue'),
    //     meta: { title: '登录' }
    // },
    {
        path: '/home/company',
        component: () => import(/* webpackChunkName: "login" */ '@/page/home/company/index.vue'),
        meta: { title: '企业' }
    }
];

const router = new VueRouter({
    routes
});

export default router;
